import { Action } from 'redux';

import * as LoginPayloads from './payloadTypes/authActionPayloads';
import { LogoutReason } from '@shared/constants';
import { UserClaims } from '@shared/util/user';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const SECOND_FACTOR_SUCCESS = 'SECOND_FACTOR_SUCCESS';

export const loginSuccess = (userName: string, userClaims: UserClaims) =>
  ({
    type: LOGIN_SUCCESS,
    payload: {
      userName,
      userClaims,
    },
  }) as const;

export const secondFactorSuccess = (userName: string, userClaims: UserClaims) =>
  ({
    type: SECOND_FACTOR_SUCCESS,
    payload: {
      userName,
      userClaims,
    },
  }) as const;
export const logoutSuccess = (reason: LogoutReason) =>
  ({
    type: LOGOUT_SUCCESS,
    payload: {
      reason,
    },
  }) as const;

export const updateUserData = (payload: LoginPayloads.UserDataPayload) =>
  ({
    type: UPDATE_USER_DATA,
    payload,
  }) as const;

export const AUTH_DATA_CHANGED = 'AUTH_DATA_CHANGED';

export function authDataChanged() {
  return {
    type: AUTH_DATA_CHANGED,
    payload: {},
  } as const;
}

export function loggedOutDueToPasswordChange() {
  return {
    type: LOGOUT_REQUEST,
    payload: {
      reason: LogoutReason.PasswordChange,
    },
  } as const;
}

export function logOutWithReasonUnknown() {
  return {
    type: LOGOUT_REQUEST,
    payload: {
      reason: LogoutReason.Unknown,
    },
  } as const;
}

export function logOutByTokenRefreshFailed() {
  return {
    type: LOGOUT_REQUEST,
    payload: {
      reason: LogoutReason.TokenRefreshFailed,
    },
  } as const;
}

/**
 * See BrowserExtensions.fs b.Logout().
 */
export function logOutByAutotests() {
  return {
    type: LOGOUT_REQUEST,
    payload: {
      reason: LogoutReason.AutotestLogout,
    },
  } as const;
}

export function logOutByUsersRequest() {
  return {
    type: LOGOUT_REQUEST,
    payload: {
      reason: LogoutReason.LogoutByRequest,
    },
  } as const;
}

export function logOutOnIdle() {
  return {
    type: LOGOUT_REQUEST,
    payload: {
      reason: LogoutReason.Idle,
    },
  } as const;
}

export const PASSWORD_CHANGED = 'PASSWORD_CHANGED';

export function passwordChanged() {
  return {
    type: PASSWORD_CHANGED,
  } as const;
}

export type AuthActions =
  | ReturnType<typeof loginSuccess>
  | ReturnType<typeof authDataChanged>
  | ReturnType<typeof secondFactorSuccess>
  | ReturnType<typeof logoutSuccess>
  | Action<typeof LOGOUT_FAILURE>
  | ReturnType<typeof passwordChanged>
  | ReturnType<typeof updateUserData>;
